module.exports = __webpack_public_path__ + "img/PR4.d7e832ef.png";